<template>
    <div class="videojs">
        <div v-if="type == 'video'" class="video-inner-container" id="video-inner-container" @mouseenter="hover = true" @mouseleave="hover=false">
            <div class="body-to-video" @click="togglePlay()"></div>
            <button class="button-full-scream" :class="{'button-full-scream-color': onVideo}" @click="goFullscreen">
                <i class="fal fa-expand" v-show="hover"/>
            </button>
            <iframe 
                id="video-youtube" 
                ref="iframeVideo"
                width="100%"
                height="100%"
                loading="lazy"
                :src="setUrl" 
                title="YouTube video player" 
                frameborder="0" 
                allow="autoplay" 
                allowfullscreen
            />
        </div>
        <div v-if="type == 'photo'" class="video-inner-container">
            <a class="photo" :href="link" :target="target ? '_' + target : ''" v-if="link">
                <img :src="urlMedia" alt="teste"/>
            </a>
            <div class="photo" v-else>
                <img :src="urlMedia" alt="teste"/>
            </div>
        </div>
    </div>
</template>

<script>

  export default {
    name: 'video-js',
    props: {
        title: {
            type: String,
            default: 'Video'
        },
        urlMedia: {
            type: String,
            required: true
        },
        autoPlay: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        }, 
        link: {
            type: String,
            default: ''
        },
        target: {
            type: String,
            default: ''
        }
    },

    data () {
        return {
            onVideo: false,
            hover: false,
            full: false
        }
    },
    computed: {
        setUrl() {
            const autoplayParam = this.autoPlay ? '1' : '0'
            return `https://www.youtube.com/embed/${this.urlMedia}?autoplay=${autoplayParam}&enablejsapi=1&version=3&controls=0&playerapiid=ytplayer&fs=1`
        }
    },
    mounted() {
        this.$root.$on('pause-video', () => {
            this.$refs.iframeVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
        });
    },

    beforeDestroy () {
        this.$root.$off('pause-video')
    },
    
    methods: {
        togglePlay() {
            this.onVideo = !this.onVideo
            const command = this.onVideo ? 'playVideo' : 'pauseVideo'
            this.$refs.iframeVideo.contentWindow.postMessage(`{"event":"command","func":"${command}","args":""}`, '*')
        },
        goFullscreen() {
            this.onVideo = true
            this.full = !this.full
            this.$refs.iframeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
            const element = document.getElementById('video-inner-container');
            if (this.full) {
                if (element.requestFullscreen) {
                    element.requestFullscreen()
                } else if (element.webkitRequestFullscreen) {
                    element.webkitRequestFullscreen()
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                }
            }
        }
    }
  }
</script>

<style lang="stylus" scoped>
    .video-inner-container
        position relative
        height: 200px
        .photo
            border 1px solid #ebebe3
            border-radius: 5px
            padding 10px
            display block
            height: 100%
            img
                width 100%
                height: 100%
                object-fit: cover
        .body-to-video
            position absolute
            height 100%
            width 100%
            display: flex
            justify-content: center
            align-items: center
            border-radius: 5px
            z-index 2
        .button-l
            z-index 4
            position relative
        .button-full-scream
            background: transparent
            color: #fff
            border: none
            cursor pointer
            font-size 20px
            position absolute
            bottom 5px
            right 5px
            z-index 4
            &:hover
                font-size 22px
                font-weight: 600
                bottom 3px
                right: 3px
            &-color
                background: #00000060
        .on-video
            background: transparent           
        iframe
            border-radius: 5px
</style>